import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { AccessTime as AccessTimeIcon } from "@mui/icons-material";
import { useDate } from "@/utility/useDate";

const CurrentTimeDisplay = () => {
  const { localizeDate, toFormattedTimeString } = useDate();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    let frameId: number;
    let lastSecond = new Date().getSeconds();

    const tick = () => {
      const current = new Date();
      if (current.getSeconds() !== lastSecond) {
        setNow(current);
        lastSecond = current.getSeconds();
      }
      frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
      <AccessTimeIcon aria-hidden focusable={false} sx={{ color: "text.secondary" }} />
      <Typography variant="body1" color="text.secondary" data-testid="current-time-display">
        {toFormattedTimeString(now)} · {localizeDate(now).toFormat("EEEE d MMMM yyyy")}
      </Typography>
    </Box>
  );
};

export default CurrentTimeDisplay;
